var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueIllustrationTop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 456,
    height: 837,
    viewBox: "0 0 456 837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Mission-result-top"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 456,
    height: 837
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mission-result-top",
    clipPath: "url(#clip-Mission-result-top)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-276.267 -11.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M1194.36,1053.31c81.86,86.64,55.54,283.1,32.14,370.5l479.57-830.633L540.708-507.882,4.267-303.218c21.1,67.149,116.142,230.967,327.478,349.044,264.17,147.6,51.114,324.848,220.88,597.6S1092.04,945.015,1194.36,1053.31Z",
    fill: "#016ed3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueIllustrationTop);
export default __webpack_public_path__ + "static/media/blue-illustration-top.556d6580559c43d2c571cb676ad255fe.svg";
export { ForwardRef as ReactComponent };